import React from 'react';

function BlogsGridSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      background: '#FFFFFF',
      padding: '64px clamp(24px, 5vw, 80px) 80px',
      boxSizing: 'border-box'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 32,
      maxWidth: 1200,
      margin: '0 auto',
      listStyle: 'none',
      padding: 0,
      marginTop: 0
    },
    card: {
      background: '#FFFFFF',
      overflow: 'hidden',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      cursor: 'pointer'
    },
    cardImgWrap: {
      position: 'relative',
      width: '100%',
      flexShrink: 0,
      overflow: 'hidden',
      padding: 0,
      margin: 0,
      lineHeight: 0
    },
    cardImg: {
      width: '100%',
      height: 'auto',
      display: 'block'
    },
    cardContent: {
      padding: '24px 20px',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    },
    cardTitle: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontSize: 'clamp(16px, 1.8vw, 19px)',
      lineHeight: 1.35,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    cardDesc: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 15,
      lineHeight: 1.6,
      letterSpacing: 0,
      color: '#838383',
      margin: 0
    }
  };

  var cards = [
    {
      img: '/moderninfrastructure.png',
      title: 'THE IMPORTANCE OF STRONG FOUNDATIONS IN MODERN INFRASTRUCTURE',
      desc: 'Understanding how precision piling ensures structural stability, safety, and long-term durability in large-scale developments.'
    },
    {
      img: '/advancedpipeline.png',
      title: 'ADVANCED PILING TECHNIQUES TRANSFORMING CONSTRUCTION',
      desc: 'A look at modern equipment and innovative methods improving efficiency and performance on complex sites.'
    },
    {
      img: '/highspeedrail.png',
      title: 'ROLE OF FOUNDATION ENGINEERING IN HIGH-SPEED RAIL PROJECTS',
      desc: 'Exploring how deep foundation solutions support large transportation networks and critical infrastructure.'
    },
    {
      img: '/precast.png',
      title: 'PRECAST VS CAST-IN-SITU PILING: CHOOSING THE RIGHT SOLUTION',
      desc: 'Comparing techniques to determine the most effective approach based on soil conditions and project demands.'
    },
    {
      img: '/moderninfrastructure.png',
      title: 'THE ROLE OF DEEP FOUNDATIONS IN MODERN INFRASTRUCTURE',
      desc: 'Discusses how advanced piling techniques ensure stability, safety, and long-term performance for high-rise and heavy civil projects.'
    },
    {
      img: '/advancedpipeline.png',
      title: 'INNOVATIONS IN PILING TECHNOLOGY TRANSFORMING CONSTRUCTION',
      desc: 'Explore the latest machinery and engineering methods improving efficiency, precision, and execution on complex project sites.'
    },
    {
      img: '/highspeedrail.png',
      title: 'KEY CHALLENGES IN HEAVY CIVIL INFRASTRUCTURE PROJECTS',
      desc: 'An insight into common groundwork challenges and how strategic planning and expert execution overcome them successfully.'
    },
    {
      img: '/precast.png',
      title: 'SUSTAINABLE PRACTICES IN FOUNDATION ENGINEERING',
      desc: 'Learn how responsible construction methods and environmental stewardship contribute to project success.'
    }
  ];

  return React.createElement(React.Fragment, null,
    React.createElement('style', null,
      '.blog-grid-card:hover { transform: translateY(-4px); box-shadow: 0 12px 36px rgba(0,0,0,0.15); }' +
      '@media (max-width: 768px) { .blogs-grid-wrap { grid-template-columns: 1fr !important; } }'
    ),
    React.createElement('section', { style: styles.section },
    React.createElement('div', { className: 'blogs-grid-wrap', style: styles.grid },
      cards.map(function (c, i) {
        return React.createElement('article', { key: i, className: 'blog-grid-card', style: styles.card },
          React.createElement('div', { style: styles.cardImgWrap },
            React.createElement('img', { src: c.img, alt: '', style: styles.cardImg })
          ),
          React.createElement('div', { style: styles.cardContent },
            React.createElement('h3', { style: styles.cardTitle }, c.title),
            React.createElement('p', { style: styles.cardDesc }, c.desc)
          )
        );
      })
    )
    )
  );
}

export default BlogsGridSection;
